import { useMemo } from 'react'
import { PRACTICE_TIMER_TYPES } from 'src/consumer/constants'
import { genericHandleChange } from 'src/consumer/helpers/utilFunctions'
import FixedTimerSettings from './FixedTimerSettings/FixedTimerSettings'
import RangeTimerSettings from './RangeTimerSettings/RangeTimerSettings'
import UnlimitedTimerSettings from './UnlimitedTimerSettings/UnlimitedTimerSettings'
import { GenericTimerSettingsContainer } from './styledComponents'

export default function TimerSettings({ timerSettings, setTimerSettings, intervalDurationLimits }) {
  const SettingsComponentToRender = useMemo(() => {
    switch (timerSettings?.durationType) {
      case PRACTICE_TIMER_TYPES.range:
        return RangeTimerSettings
      case PRACTICE_TIMER_TYPES.fixed:
        return FixedTimerSettings
      default:
        return UnlimitedTimerSettings
    }
  }, [timerSettings?.durationType])

  function handleChange(eve) {
    genericHandleChange(eve, setTimerSettings)
  }

  function setIntervals(prevNewVal) {
    const isFunction = typeof prevNewVal === 'function'
    if (isFunction) {
      setTimerSettings((prevTimer) => ({
        ...prevTimer,
        intervals: prevNewVal(prevTimer?.intervals || []),
      }))
    } else {
      setTimerSettings((prevTimer) => ({
        ...prevTimer,
        intervals: prevNewVal,
      }))
    }
  }

  return (
    <GenericTimerSettingsContainer>
      <SettingsComponentToRender
        {...{
          timerSettings,
          setTimerSettings,
          handleChange,
          intervalDurationLimits,
          setIntervals,
        }}
        intervals={timerSettings?.intervals}
      />
    </GenericTimerSettingsContainer>
  )
}
